import { useState, useEffect } from 'react'
import { useMaterialUIController } from 'context'
import { setLayout } from 'context'
import { useParams } from 'react-router-dom';

function HtmlTemplate() {
     const { id } = useParams();
    const [, dispatch] = useMaterialUIController();
    const [data, setData] = useState([])

    useEffect(() => {
        setLayout(dispatch, "page");
        ; (async () => {
            try {
                let url = process.env.REACT_APP_ENV == 'dev' ? process.env.REACT_APP_API_URL : `${location.origin}/api`
                setData(`${url}/public/images/html/${id}`)
            } catch (err) {
                console.error('err', err)
            }
        })()
    }, [])


    return (
        <div style={{ width: '100%', height: '100vh', overflow: 'hidden' }}>
            {
                data &&
                <iframe
                    src={data}
                    style={{
                        width: '100%',
                        height: '100%',
                        border: 'none',
                        overflow: 'hidden',
                    }}
                // title="Rendered HTML"
                />
            }
        </div>
    )
}

export default HtmlTemplate